'use strict'

// One labelled cluster column in the home page's grouped app launcher
// (WORK / TEAM / INSIGHTS). Header on top, then a vertical list of
// AppListItem rows. The BUILD group renders differently — it gets a
// dedicated row of AppHeroCards instead of this column treatment.
//
// Per-column state (fed by main.js as childrenAs: 'state'):
//   { title, accent?, items }
//   - title:  group label (e.g. 'WORK', 'TEAM', 'INSIGHTS')
//   - accent: design-system color for the label text — e.g. 'green'
//             for BUILD to land the brief's accent rule; falsy = neutral
//   - items:  array of AppListItem-shaped objects (title, caption,
//             icon, route)
export const AppGroupColumn = {
  flow: 'y',
  gap: 'B',

  GcHeader: {
    tag: 'span',
    fontSize: 'Y2',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: (el, s) => s.accent || 'caption',
    // i18n — same one call as AppListItem's Title: a shipped group label is a
    // polyglot key, a workspace's own group name passes through unchanged.
    text: (el, s) => el.call('polyglot', s.title || '')
  },

  GcItems: {
    flow: 'y',
    gap: 'V',
    childExtends: 'AppListItem',
    childrenAs: 'state',
    children: (el, s) => s.items || []
  }
}
